import { EoiService } from "../../services/eoi/eoi.service";
import { ErrorHandlerService } from "../../services/shared/error-handler.service";
import { CookieService } from "ngx-cookie-service";
import { Router, ActivatedRoute } from "@angular/router";
import { LeadsService } from "../../services/lead-service/lead-service.service";
import { ChangeDetectorRef, Component, OnInit, Renderer2 } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray,
} from "@angular/forms";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import swal from "sweetalert2";
import { ProjectsService } from "../../services/projects/projects.service";
import { UserServiceService } from "../../services/user-service/user-service.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { MatDialog } from "@angular/material";
import { EditEoiCustomerDialogComponent } from "../dialogs/edit-eoi-customer-dialog.component";

import * as moment from "moment";
import { MarketingService } from "../../services/marketing/marketing.service";
import { OcrService } from "../../services/ocr/ocr.service";
import { OcrRecord } from "../../models/ocr.model";

@Component({
  selector: "app-eoi",
  templateUrl: "./eoi.component.html",
  styleUrls: ["./eoi.component.css"],
})
export class EoiComponent implements OnInit {
  isLeadSelected = false;
  documentForm: FormGroup;
  showError: boolean;
  messages: any;
  leadphonenumber: string;
  sub: any;
  unitId: any;
  leads: any;
  leadsArrayString: any = [];
  chosenLead: any;

  /** Only spoken when a scan cannot finish the job. */
  ocrMessage: string = null;
  ocrMessageSeverity = "warning";
  ocrLookupBusy = false;
  ocrUncertainFields: string[] = [];
  loadingData: boolean = false;
  arrSearch: any = [];
  dataFromSearch: any;
  unit_serial: any;
  blockTimer: any;
  disabledSubmitWhileSending: boolean = false;
  deal_types: any = ["Direct", "In-Direct"];
  direct_option: any = ["Individual", "Ambassador"];
  ambassadors: any;
  brokers: any;
  deal_type: any;
  garage_price: any;
  double_garage_price: any;
  unit_garage_price: any;
  methods: any;
  commercial_methods: any;
  installment_years: any;
  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));
  project_type: any;
  rent_types: any;
  sale_types: any;
  payment_type: any;
  is_overseas: any;
  type: any;

  ready_to_add_contract_sale: boolean = true;
  ready_to_add_contract_rent: boolean = false;
  rent_mode: any;
  sale_mode: any;

  projects: any;
  eois: any;

  payment_types = [
    { name: "cash" },
    { name: "visa" },
    { name: "transfer" },
    { name: "cheque" },
  ];

  edit_payment_modal_data: any;

  unitFloors: any = [0, 1, 2, 3, 4, 5, 6, 7];
  unitTypes: any = [];
  designTypes: any = [];

  channels: any;
  require_channels = [];
  leadSources = [];

  eoi_details: any[] = [
    {
      eoi_value: null,
      design_type: null,
      unit_type: null,
      unit_floor: null,
      beds_number: null,
      has_nany_room: false,
      interested_area_from: null,
      interested_area_to: null,
    },
  ];
  allAgentsDropdownSettings = {
    singleSelection: true,
    idField: "id",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };
  agents: any;
  generic_types: any;

  incentive_users: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private leadsService: LeadsService,
    private slimLoadingBarService: SlimLoadingBarService,
    public route: ActivatedRoute,
    public projectService: ProjectsService,
    public eoiService: EoiService,
    public errorHandlerService: ErrorHandlerService,
    public renderer2: Renderer2,
    public http: HttpClient,
    private userService: UserServiceService,
    private marketingService: MarketingService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog
  ,
    private ocrService: OcrService
  ) {
    this.getProjects();
    this.createForm();
  }

  getIncentiveUsers(broker_id: number) {
    this.incentive_users = [];
    this.documentForm.patchValue({
      broker_incentive_id: null,
    });
    this.userService.get_incentive_users(broker_id).subscribe(
      (res: any) => {
        this.incentive_users = res;
        console.log(this.agents);
      },
      (err) => {
        console.log(err);
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getAgents() {
    this.leadsService.getAgents().subscribe(
      (data: any) => {
        this.agents = data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        console.log(err);
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  assignAgent(value, index) {
    this.eoi_details[index].user_id = value.id;
  }

  dateFormat() {
    $(document).ready(function () {
      ($("#lead_birthday") as any).datepicker({
        format: "yyyy-mm-dd",
      });
    });
  }

  getLeads() {
    // this.getAllLeads();
  }

  getProjects() {
    this.projectService
      .getProjects({ is_select_form: true })
      .subscribe((res: any) => {
        this.projects = res;
      });
  }

  getPaymentTermsByProjectId(project_id) {
    console.log(project_id);
    this.userService.getProjectPaymentTerms(project_id).subscribe(
      (res) => {
        let arr: any = res;
        this.methods = arr;
        console.log(this.methods);
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  observableSource = (keyword: any): any => {
    let baseUrl: string = environment.api_base_url;
    let data = {
      keyword: keyword,
    };
    if (keyword) {
      return this.http
        .get(`${baseUrl}leads?keyword=${keyword}`)
        .map((res: any) => {
          console.log(res.data.length);
          if (res.data.length == 0) {
            let arr = [];
            return arr;
          } else {
            this.arrSearch = [];
            this.dataFromSearch = res.data;
            res.data.forEach((e) => {
              this.arrSearch.push(`${e.name} / ${e.id}`);
            });
            console.log(
              "1- searching found these data (this.dataFromSearch)",
              this.dataFromSearch
            );
            return this.arrSearch;
          }
        });
    } else {
      return Observable.of([]);
    }
  };

  getAllLeads() {
    this.leadsService.getLeads().subscribe(
      (data) => {
        console.log(data);
        this.convertLeads(data);
        return this.leadsArrayString;
      },
      (err) => console.log(err)
    );
  }

  convertLeads(data) {
    this.leadsArrayString = [];
    this.leads = data.data;
    this.leads.forEach((element) => {
      this.leadsArrayString.push(element.name);
    });
  }


  /**
   * Fill the identity fields from a scanned national ID, then try to attach
   * the lead it belongs to.
   *
   * The lookup reuses this form's own path: the results are put in
   * dataFromSearch and chosenLead is set to the "name / id" string
   * getLeadDetails() expects, so the existing code does the patching.
   *
   * Only a `validated` national number is used as the key. A misread but
   * well-formed fourteen-digit number would otherwise attach this EOI to the
   * wrong person, which is the silent failure the OCR pipeline exists to stop.
   */
  onIdScanned(record: OcrRecord): void {
    const uncertain: string[] = [];
    const self = this;

    const apply = function (controlName: string, identityKey: string, transform?: any) {
      const control = self.documentForm.get(controlName);
      if (!control) {
        return;
      }
      const raw = self.ocrService.identityValue(record, identityKey);
      if (raw === null) {
        return;
      }
      const value = transform ? transform(raw) : raw;
      if (value === null || value === "") {
        return;
      }
      control.patchValue(value);
      control.markAsDirty();
      if (self.ocrService.needsVerification(record, identityKey)) {
        uncertain.push(controlName);
      }
    };

    apply("lead_national_id", "national_number", function (raw) {
      const digits = raw.replace(/\D/g, "");
      return digits ? digits : null;
    });
    apply("lead_birthday", "birth_date");
    apply("lead_issue_date", "id_issue_date");
    apply("lead_arabic_name", "full_name_ar");
    apply("lead_address", "address_ar");
    apply("lead_job_title", "occupation_ar");
    apply("lead_marital_status", "marital_status");
    apply("lead_district", "governorate");

    this.ocrUncertainFields = uncertain;
    this.ocrMessage = null;

    const critical = this.ocrService.criticalFlags(record);
    if (critical.length) {
      this.ocrMessageSeverity = "danger";
      this.ocrMessage =
        "This scan did not verify: " + critical[0] + " Check every filled field against the card.";
      return;
    }

    if (!this.chosenLead) {
      this.findLeadFromScan(record, uncertain.length);
    }
  }

  onIdScanCleared(): void {
    this.ocrMessage = null;
    this.ocrUncertainFields = [];
  }

  /** True when a scan filled this control but nothing confirmed it. */
  isOcrUncertain(controlName: string): boolean {
    return this.ocrUncertainFields.indexOf(controlName) !== -1;
  }

  private findLeadFromScan(record: OcrRecord, uncertainCount: number): void {
    const nationalNumber = this.ocrService.verifiedNationalNumber(record);
    const filledNote =
      "The card was read" +
      (uncertainCount
        ? " (" + uncertainCount + " field(s) highlighted for checking)."
        : ".");

    if (!nationalNumber) {
      this.ocrMessageSeverity = "warning";
      this.ocrMessage =
        filledNote +
        " The national number could not be confirmed, so no lead was looked up - find the lead manually.";
      return;
    }

    this.ocrLookupBusy = true;
    this.leadsService.filterLeadByName(nationalNumber).subscribe(
      (response: any) => {
        this.ocrLookupBusy = false;
        const leads = response && response.data && response.data.length ? response.data : [];

        if (leads.length === 1) {
          const lead = leads[0];
          // Feed this form's own selection path rather than duplicating it.
          this.dataFromSearch = leads;
          this.chosenLead = (lead.name ? lead.name : "") + " / " + lead.id;
          this.getLeadDetails();
          this.ocrMessage = null;
          return;
        }

        if (leads.length > 1) {
          this.dataFromSearch = leads;
          this.chosenLead = nationalNumber;
          this.ocrMessageSeverity = "warning";
          this.ocrMessage =
            leads.length + " leads share national number " + nationalNumber + " - pick the right one and press GET INFO.";
          return;
        }

        this.chosenLead = nationalNumber;
        this.ocrMessageSeverity = "warning";
        this.ocrMessage =
          filledNote +
          " No lead was found for national number " + nationalNumber +
          ", so none is attached - select or create the lead before saving.";
      },
      () => {
        this.ocrLookupBusy = false;
        this.ocrMessageSeverity = "danger";
        this.ocrMessage = filledNote + " The lead search failed just now - find the lead manually.";
      }
    );
  }

  getLeadDetails(): any {
    if (!this.chosenLead) {
      swal("Lead name can not be empty!");
    } else {
      if (this.dataFromSearch.length == 0) {
        swal("No Lead with that name.");
      } else {
        console.log("Choosen lead", this.chosenLead);

        let found = false;
        this.isLeadSelected = false;
        this.dataFromSearch.forEach((element) => {
          const nameArr = this.chosenLead.replace(/\s/g, "").split("/");
          const leadId = nameArr[nameArr.length - 1];
          if (element.id == leadId) {
            console.log(this.chosenLead);
            console.log(element);

            // this.eois = element.project.eois;
            this.documentForm.patchValue({
              lead_id: element.id,
              lead_name: element.name,
              lead_address: element.address,
              lead_home_phone: element.phone_2,
              lead_phone: element.phone,
              lead_other_phone: element.phone_2,
              lead_birthday: element.date_of_birth,
              lead_issue_date: element.national_issue_date,
              lead_marital_status: element.martial_status,
              lead_email: element.email,
              lead_job_title: element.job_title,
              lead_workplace: element.workplace,
              lead_work_address: element.work_address,
              lead_nationality: element.nationality,
              lead_fax_number: element.fax_num,
              lead_national_id: element.id_number,
              project_id: element.interested_project_id,
              deal_type: element.lead_channel
                ? element.lead_channel.name
                : null,
              deal_category: element.lead_channel
                ? element.lead_channel.name === "Direct"
                  ? element.lead_source
                  : ""
                : "",
              lead_source: element.lead_source,
              ambassador_id: element.ambassador_id,
              broker_id: element.broker_id,
              cheque_number: element.cheque_number,
            });
            if (this.documentForm.get("broker_id").value) {
              this.getIncentiveUsers(this.documentForm.get("broker_id").value);
            }
            setTimeout(() => {
              this.documentForm.patchValue({
                lead_code: element.code,
                lead_home_code: element.code_2,
                lead_other_code: element.code_3,
                lead_phone_without_code: element.phone_without_code,
                lead_home_phone_without_code: element.phone_2_without_code,
                lead_other_phone_without_code: element.phone_3_without_code,
              })
            }, 500);
            this.onProjectChange();
            this.cdr.detectChanges();
            found = true;
            this.isLeadSelected = true;
          }
        });
        if (!found) swal("No Lead with that name.");
      }

      this.leadsService.filterLeadByName(this.chosenLead).subscribe(
        (data) => {
          console.log(data);
          this.convertLeads(data);
          console.log(this.leadsArrayString);
        },
        (err) => console.log(err)
      );
    }
  }

  ngOnInit() {
    this.getLeads();
    this.dateFormat();
    // this.getPaymentTypes();
    this.deal_type_change();
    this.getChannels();
    this.getAmbassadors();
    this.getBrokers();
    this.getAgents();
  }

  getChannels() {
    this.slimLoadingBarService.start();
    this.marketingService.getChannels().subscribe(
      (res: any) => {
        this.channels = res;
        this.require_channels.map((a) => a());
        this.require_channels = null;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  removeEoiDetails(index) {
    this.eoi_details = this.eoi_details.filter(
      (elm, curr_index) => index !== curr_index
    );
  }

  addEoiDetails() {
    this.eoi_details.push({
      eoi_value: null,
      design_type: null,
      unit_type: null,
      unit_floor: null,
      beds_number: null,
      has_nany_room: null,
      interested_area_from: null,
      interested_area_to: null,
      generic_type: null,
    });
  }

  valueChanged(ev) {
    this.chosenLead = ev;
    // this.searchForInputs(ev);
  }

  createForm() {
    this.documentForm = this.fb.group({
      lead_id: [0, Validators.required],
      lead_name: ["", Validators.required],
      lead_address: ["", Validators.required],
      lead_home_phone: [""],
      lead_phone: ["", Validators.required],
      lead_other_phone: [""],
      lead_nationality: ["", Validators.required],
      lead_birthday: ["01-01-1980", Validators.required],
      lead_national_id: ["", Validators.required],
      lead_issue_date: [""],
      lead_district: ["", Validators.required],
      lead_marital_status: [""],
      lead_email: [""],
      lead_job_title: [""],
      lead_workplace: [""],
      lead_work_address: [""],
      lead_fax_number: [""],
      project_id: ["", Validators.required],
      payment_type: [""],
      broker_incentive_id: [""],
      cheque_number: [""],
      is_overseas: ["", Validators.required],
      deal_type: ["", Validators.required],
      lead_source: [""],
      deal_category: [""],
      broker_id: [""],
      ambassador_id: [""],
      // interested_type: [""],
      lead_arabic_name: [""],
      job_title: [""],
      national_issue_date: [""],
      workplace: [""],
      lead_code: [""],
      lead_home_code: [""],
      lead_other_code: [""],
      lead_phone_without_code: [""],
      lead_home_phone_without_code: [""],
      lead_other_phone_without_code: [""],
      lead_phone_error: [""],
      lead_other_phone_error: [""],
      lead_home_phone_error: [""],
      // phase: [""],
    });
    this.documentForm.valueChanges.subscribe((event) =>
      console.log(
        "Invalid controls are",
        this.findInvalidControls(this.documentForm)
      )
    );
  }

  getGenericTypes(project_id) {
    this.slimLoadingBarService.start();
    this.eoiService.getGenericTypes(project_id).subscribe(
      (data: any) => {
        this.generic_types = data;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  findInvalidControls(form: FormGroup) {
    const invalid = [];
    const controls = form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    console.log("invalid controls are", invalid);
    return invalid;
  }

  division_type_change() {
    console.log("division_type_change changed");
    this.documentForm.get("deal_category").valueChanges.subscribe((val) => {
      if (val == "Ambassador") {
        console.log("Ambassador");
        this.documentForm.addControl(
          "ambassador_id",
          new FormControl("", Validators.required)
        );
      } else if (val == "Individual") {
        console.log("Individual");
      }
    });
  }

  deal_type_change() {
    this.documentForm.get("deal_type").valueChanges.subscribe((val) => {
      console.log(`-------------------${val}`);
      if (Array.isArray(this.require_channels)) {
        this.require_channels.push(() => {
          this.channels.forEach((e) => {
            if (e.name == val) {
              this.leadSources = e.sources;

              if (val == "Direct") {
                // active
                this.setFormFieldRequired("deal_category");

                // deactive
                this.removeFormFieldRequired("lead_source");
                this.removeFormFieldRequired("broker_id");
                this.removeFormFieldRequired("ambassador_id");
              } else if (val == "In-Direct") {
                // active
                this.setFormFieldRequired("lead_source");

                // deactive
                this.removeFormFieldRequired("deal_category");
              }
            }
          });
        });
      } else {
        this.channels.forEach((e) => {
          if (e.name == val) {
            this.leadSources = e.sources;

            if (val == "Direct") {
              // active
              this.setFormFieldRequired("deal_category");

              // deactive
              this.removeFormFieldRequired("lead_source");
              this.removeFormFieldRequired("broker_id");
              this.removeFormFieldRequired("ambassador_id");
            } else if (val == "In-Direct") {
              // active
              this.setFormFieldRequired("lead_source");

              // deactive
              this.removeFormFieldRequired("deal_category");
            }
          }
        });
      }
    });

    this.documentForm.get("lead_source").valueChanges.subscribe((val) => {
      if (val == "Ambassador") {
        // active
        this.setFormFieldRequired("ambassador_id");

        // deactive
        this.removeFormFieldRequired("broker_id");
      } else if (val == "Broker") {
        // active
        this.setFormFieldRequired("broker_id");

        // deactive
        this.removeFormFieldRequired("ambassador_id");
      }
    });
  }

  setFormFieldRequired(field) {
    this.documentForm.get(field).setValidators([Validators.required]);
    this.documentForm.get(field).updateValueAndValidity();
  }

  removeFormFieldRequired(field) {
    this.documentForm.get(field).setValue("");
    this.documentForm.get(field).setValidators(null);
    this.documentForm.get(field).updateValueAndValidity();
  }

  onProjectChange(event?) {
    let project_id = this.documentForm.get("project_id").value;
    console.log(project_id);
    this.eois = [];
    this.projects.forEach((project) => {
      if (project.id == project_id) {
        this.eois = project.eois;
      }
    });
    if (project_id) {
      this.getUnitTypes(project_id);
      this.getdesignTypes(project_id);
      this.getGenericTypes(project_id);
    }
  }
  getUnitTypes(project_id) {
    this.slimLoadingBarService.start();
    this.unitTypes = [];
    // this.documentForm.get("unit_floor").setValue("");
    this.projectService.getUnitTypes(project_id).subscribe(
      (data) => {
        this.unitTypes = data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }
  getdesignTypes(project_id) {
    this.slimLoadingBarService.start();
    // this.documentForm.get("design_type").setValue("");
    this.designTypes = [];

    this.projectService.getDesignTypes(project_id).subscribe(
      (data) => {
        this.designTypes = data;
        console.log(this.designTypes);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }
  getAmbassadors() {
    this.slimLoadingBarService.start();
    let params = {
      paginate: false,
    };
    this.userService.getAmbasdors(params).subscribe(
      (data: any) => {
        this.ambassadors = data;
        console.log(this.ambassadors);
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getBrokers() {
    this.slimLoadingBarService.start();
    this.userService.getBorkers().subscribe(
      (data: any) => {
        this.brokers = data;
        console.log(this.brokers);
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  receivePhone(event, phone, code, err) {
    this.documentForm.get(err).setValue(event.phoneError);
    this.documentForm.get(phone).setValue(event.phone);
    this.documentForm.get(code).setValue(event.code);
  }

  submit() {
    let formModel = Object.assign({}, this.documentForm.value);
    console.log(this.documentForm.value);
    if (formModel.lead_id == 0) {
      swal("Please assign lead to eoi.", "", "warning");
    } else {
      if (!formModel.lead_name) {
        swal(
          "Get Lead Info!",
          "Make sure assigning lead to eoi by getting its info!",
          "warning"
        );
      } else {
        this.slimLoadingBarService.start(() => {
          console.log("Loading complete");
        });

        // ambassadors and brokers
        // if (this.documentForm.value.ambassador_id)
        //   formModel.ambassador_id = this.documentForm.value.ambassador_id.id;
        // if (this.documentForm.value.broker_id)
        //   formModel.broker_id = this.documentForm.value.broker_id.id;
        this.disabledSubmitWhileSending = true;
        const paylaod = {
          ...formModel,
          eoi_details: this.eoi_details,
        };
        this.eoiService.addEoi(paylaod).subscribe(
          (data) => {
            console.log(data);
            swal(
              "Cool!",
              "EOI is added successfully, pending accountant approve!",
              "success"
            );
            this.router.navigate(["/pages/eoi-table"]);
            this.slimLoadingBarService.complete();
            this.disabledSubmitWhileSending = false;
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.complete();
            this.disabledSubmitWhileSending = false;
          }
        );
      }
    }
  }

  addPaymentTypeModalSubmit(modal) {
    let payload = {
      name: this.payment_type,
    };
    console.log(payload);
    this.slimLoadingBarService.start();
    this.eoiService.addPaymentType(payload).subscribe(
      (res: any) => {
        console.log(res);
        // this.getPaymentTypes();
        this.payment_type = null;
        modal.close();
        swal("Success", "Added Payment Type successfully", "success");
        this.slimLoadingBarService.complete();
      },
      (err) => {
        console.log(err);
        this.slimLoadingBarService.reset();
      }
    );
  }

  // getPaymentTypes() {
  //   this.slimLoadingBarService.start();
  //   this.eoiService.getPaymentTypes().subscribe(
  //     (res: any) => {
  //       this.payment_types = res;
  //       this.slimLoadingBarService.complete();
  //     },
  //     (err) => {
  //       this.slimLoadingBarService.reset();
  //     }
  //   );
  // }

  deletePayment(id) {
    this.slimLoadingBarService.start();
    this.eoiService.deletePaymentType(id).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        // this.getPaymentTypes();
        swal("Success", "Deleted Payment Type Successfully", "success");
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  editPayment(modal, payment) {
    this.edit_payment_modal_data = JSON.parse(JSON.stringify(payment));
    modal.open();
  }

  editPaymentTypeModalSubmit(modal) {
    this.slimLoadingBarService.start();
    let payload = {
      name: this.edit_payment_modal_data.name,
    };
    this.eoiService
      .editPaymentType(this.edit_payment_modal_data.id, payload)
      .subscribe(
        (res: any) => {
          this.slimLoadingBarService.complete();
          modal.close();
          swal("Success", "Edited Payment Type Successfully", "success");
          // this.getPaymentTypes();
        },
        (err) => {
          this.slimLoadingBarService.reset();
        }
      );
  }

  openEditCustomerDialog() {
    // Get customer data from form
    const customerData = {
      lead_name: this.documentForm.get('lead_name').value,
      lead_phone: this.documentForm.get('lead_phone').value,
      lead_code: this.documentForm.get('lead_code').value,
      lead_phone_without_code: this.documentForm.get('lead_phone_without_code').value,
      lead_home_phone: this.documentForm.get('lead_home_phone').value,
      lead_home_code: this.documentForm.get('lead_home_code').value,
      lead_home_phone_without_code: this.documentForm.get('lead_home_phone_without_code').value,
      lead_other_phone: this.documentForm.get('lead_other_phone').value,
      lead_other_code: this.documentForm.get('lead_other_code').value,
      lead_other_phone_without_code: this.documentForm.get('lead_other_phone_without_code').value,
      lead_email: this.documentForm.get('lead_email').value,
      lead_national_id: this.documentForm.get('lead_national_id').value,
      lead_nationality: this.documentForm.get('lead_nationality').value,
      lead_birthday: this.documentForm.get('lead_birthday').value,
      lead_address: this.documentForm.get('lead_address').value,
      lead_district: this.documentForm.get('lead_district').value,
      lead_arabic_name: this.documentForm.get('lead_arabic_name').value,
      lead_issue_date: this.documentForm.get('lead_issue_date').value,
      lead_job_title: this.documentForm.get('lead_job_title').value,
      lead_workplace: this.documentForm.get('lead_workplace').value,
      lead_work_address: this.documentForm.get('lead_work_address').value,
      lead_fax_number: this.documentForm.get('lead_fax_number').value,
      lead_marital_status: this.documentForm.get('lead_marital_status').value,
    };

    const dialogRef = this.dialog.open(EditEoiCustomerDialogComponent, {
      width: '60vw',
      height: '95vh',
      data: {
        eoi_id: this.documentForm.get('lead_id').value,
        customer: customerData,
        title: 'Edit Customer Info'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Update form with edited data
        this.documentForm.patchValue({
          lead_name: result.lead_name,
          lead_phone: result.lead_phone,
          lead_code: result.lead_code,
          lead_phone_without_code: result.lead_phone_without_code,
          lead_home_phone: result.lead_home_phone,
          lead_home_code: result.lead_home_code,
          lead_home_phone_without_code: result.lead_home_phone_without_code,
          lead_other_phone: result.lead_other_phone,
          lead_other_code: result.lead_other_code,
          lead_other_phone_without_code: result.lead_other_phone_without_code,
          lead_email: result.lead_email,
          lead_national_id: result.lead_national_id,
          lead_nationality: result.lead_nationality,
          lead_birthday: result.lead_birthday,
          lead_address: result.lead_address,
          lead_district: result.lead_district,
          lead_arabic_name: result.lead_arabic_name,
          lead_issue_date: result.lead_issue_date,
          lead_job_title: result.lead_job_title,
          lead_workplace: result.lead_workplace,
          lead_work_address: result.lead_work_address,
          lead_fax_number: result.lead_fax_number,
          lead_marital_status: result.lead_marital_status,
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/eois/eoi/eoi.component.ts